import { RootState } from "redux/store";

export const selectBookwellGroup = (state: RootState) =>
  state.bookwell.bookwellGroup;

export const selectLocationId = (state: RootState) =>
  state.bookwell.locationId;